import React, { useRef } from 'react';
import LaboratoryRequestTemplateList, {
	LaboratoryRequestTemplateListHandle,
} from '../LaboratoryRequestTemplateList/LaboratoryRequestTemplateList';
import { useAppContext } from '../../../../../Services/AppContext';
import { useDisclose } from '../../../../Modal/Hooks/useDisclose';
import LaboratoryRequestTemplateCreateModal from '../LaboratoryRequestTemplateCreate/LaboratoryRequestTemplateCreateModal';
import SubTabNavigationStepper from '../../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import { NavigationStepperItemType } from '../../../../../Components/Stepper/NavigationStepper';
import { LaboratoryTemplateType } from '../../../Enums/LaboratoryTemplateType.enum';

interface Props {
	workplaceId: string;
}

const LaboratoryRequestTemplateWrapper: React.FC<Props> = ({ workplaceId }) => {
	const laboratoryRequestTemplateWorkplaceListRef =
		useRef<LaboratoryRequestTemplateListHandle>(null);
	const laboratoryRequestTemplatePersonalListRef =
		useRef<LaboratoryRequestTemplateListHandle>(null);
	const { userData } = useAppContext();
	const { onOpen, onClose, isOpen } = useDisclose();

	const onCreateTemplate = (templateType: LaboratoryTemplateType) => {
		onClose();
		if (templateType === LaboratoryTemplateType.DOCTOR) {
			laboratoryRequestTemplatePersonalListRef.current?.refresh();
		} else {
			laboratoryRequestTemplateWorkplaceListRef.current?.refresh();
		}
	};

	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.laboratoryRequestTemplateWrapper.addButton',
			key: 'newLaboratoryRequest',
			onClick: () => onOpen(),
		},
		{
			name: 'component.laboratoryRequestTemplateWrapper.workplaceTemplates',
			key: 'workplaceTemplates',
			component: () => (
				<LaboratoryRequestTemplateList
					key='workplaceTemplates'
					type={LaboratoryTemplateType.WORKPLACE}
					doctorId={userData.id}
					workplaceId={workplaceId}
					ref={laboratoryRequestTemplateWorkplaceListRef}
				/>
			),
		},
		{
			name: 'component.laboratoryRequestTemplateWrapper.personalTemplates',
			key: 'personalTemplates',
			component: () => (
				<LaboratoryRequestTemplateList
					key='personalTemplates'
					type={LaboratoryTemplateType.DOCTOR}
					doctorId={userData.id}
					workplaceId={workplaceId}
					ref={laboratoryRequestTemplatePersonalListRef}
				/>
			),
		},
	];

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='workplaceTemplates'
				canSkip
				showStepNumbers={false}
			/>
			{isOpen && (
				<LaboratoryRequestTemplateCreateModal
					workplaceId={workplaceId}
					doctorId={userData.id}
					isOpen
					onClose={onClose}
					onCreate={onCreateTemplate}
				/>
			)}
		</>
	);
};

export default LaboratoryRequestTemplateWrapper;
